import { FC } from 'react'
import { useNavigate } from 'react-router'
import { IconUpload, IconX, IconWallet } from '@tabler/icons-react'
import { Dialog, DialogContent } from '../../atoms/dialog'
import { PrimaryButton } from '../../atoms/buttons/PrimaryButton'
import Typography from '../../atoms/Typography'
import { ROUTES } from 'src/types/routes'
import { formatFileSize } from 'src/enviroment/lib/formatters/format-file-size'
import { GradientBorderButton } from '../../atoms/buttons/GradientBorderButton'

interface StorageLimitExceededDialogProps {
  open?: boolean
  onOpenChange?: (open: boolean) => void
  usedBytes?: number
  limitBytes?: number | null
}

const StorageLimitExceededDialog: FC<StorageLimitExceededDialogProps> = ({
  open = true,
  onOpenChange,
  usedBytes = 0,
  limitBytes = null,
}) => {
  const navigate = useNavigate()

  const handleUpgrade = () => {
    onOpenChange?.(false)
    navigate(ROUTES.SUBS)
  }

  const handleMaybeLater = () => {
    onOpenChange?.(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[668px] border border-gray-500 bg-gray-900 p-8 text-center [&>button]:hidden">
        <div className="flex flex-col items-center gap-4">
          <div className="flex h-14 w-14 items-center justify-center rounded-full bg-red-light">
            <IconUpload className="h-7 w-7 text-red-ramo" />
          </div>

          <div className="space-y-2">
            <Typography variant="xl-bold" className="text-gray-50">
              Upload Limit Reached
            </Typography>
            <Typography variant="sm" className="text-base text-gray-300">
              You&apos;ve reached your storage limit ({formatFileSize(usedBytes)} / {limitBytes != null ? formatFileSize(limitBytes) : '—'} used).
              <br />
              Upgrade to Pro to upload unlimited files and unlock more features.
            </Typography>
          </div>

          <div className="mt-4 flex w-full justify-center gap-3">
            <GradientBorderButton onClick={handleMaybeLater} gradientSize="lg">
              <IconX className="h-6 w-6" />
              <Typography variant="lg" className="text-gray-50">
                Maybe Later
              </Typography>
            </GradientBorderButton>
            <PrimaryButton size="lg" leftIcon={<IconWallet className="h-5 w-5" />} onClick={handleUpgrade}>
              <Typography variant="lg" className="text-gray-50">
                Upgrade Plan
              </Typography>
            </PrimaryButton>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default StorageLimitExceededDialog
